import { useCallback, useContext } from "react";
import { GlobalModalContext } from "src/utils/GlobalModal/GlobalModalContext";
import __ from "src/utils/Translations";
import AbsenceRequestRequireCorrectionForm from "src/Pages/Company/Absences/AbsenceRequest/AbsenceRequestRequireCorrectionForm";

export const useRequireCorrection = () => {
  const { setModal, resetModal } = useContext(GlobalModalContext);

  const requireCorrection = useCallback(
    (absenceRequestId: string) => {
      if (typeof setModal === "function") {
        setModal({
          open: true,
          title: <>{__("Poproś o poprawę wniosku")}</>,
          description: __(
            "Podaj czytelny powód, dla którego nie zaakceptowałeś wniosku. Pracownik otrzyma powiadomienie e-mail z prośbą o wprowadzenie zmian, po czym będziesz mógł ponownie zaakceptować ten wniosek."
          ),
          customElements: (
            <AbsenceRequestRequireCorrectionForm
              absenceRequestId={absenceRequestId}
              resetModal={resetModal}
            />
          ),
          actions: [],
        });
      }
    },
    [resetModal, setModal]
  );

  return { requireCorrection };
};
